import ImportExportPage from "@/views/import-export-page/index.vue"
import Vue from "vue"

let instance = null

const createInstance = () => {
  const NotifyConstructor = Vue.extend(ImportExportPage)
  instance = new NotifyConstructor({
    data() {
      return {
        visible: true
      }
    }
  })
  instance.$mount(document.createElement("div"))
  document.body.appendChild(instance.$el)
  return instance
}

export const $notify = {
  show() {
    if (!instance) {
      instance = createInstance()
    } else {
      instance.visible = true
    }
  },
  hide() {
    if (instance) {
      instance.visible = false
    }
  },
  destroy() {
    if (instance) {
      document.body.removeChild(instance.$el)
      instance.$destroy()
      instance = null
    }
  }
}

const ImportExportPagePlugin = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, "$ImportExportPage", {
      value: $notify,
      writable: false,
      configurable: false
    })
  }
}

export default ImportExportPagePlugin
